import React, { useState, useEffect } from "react";
const EditableCell = ({ value, updateDB, isReadOnly }) => {

    const handleBlur = (e) => {
        if (isReadOnly) return;

        const currentValue = e.target.value;
        const finalValue = currentValue === "" ? "0" : currentValue;

        updateDB(finalValue);
    };

    return (
        <input
            key={value}
            className="form-control"
            disabled={isReadOnly}
            defaultValue={value }
            onChange={() => {}}
            onBlur={handleBlur}
            onKeyDown={(e) => e.key === "Enter" && e.target.blur()}
            style={{ textAlign: "center", height: '100%', }}
        />
    );
};

export default EditableCell;
